import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import AddClinic from "./add-clinic-domain";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import Loader from "../../control-components/loader/loader";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

function ClinicDomain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [loading, setLoading] = useState(false);
  const [isAddClinic, setIsAddClinic] = useState(false);
  const [clinicDomains, setClinicDomains] = useState([]);

  useEffect(() => {}, []);

  const handleAddClinic = () => {
    setIsAddClinic(true);
  };

  const handleCloseClinic = () => {
    setIsAddClinic(false);
  };

  // const getAllClinicDomains = async () => {
  //     setLoading(true)
  //     await ClinicDomainService.getClinicDomains()
  //         .then(result => {
  //             if (result.resultData.length > 0) {
  //                 setClinicDomains(result.resultData)

  //             }
  //             setLoading(false)
  //         }).catch(error => {
  //             setLoading(false)
  //             NotificationManager.error(error);
  //         });
  // }

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
  };

  return (
    <div>
      <button class="green-btn btn-primary" onClick={handleAddClinic}>
        Add Clinic Domain
      </button>

      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {loading && <Loader />}
                <Grid
                  data={orderBy(
                    clinicDomains.slice(page, pageSize + page),
                    sort
                  ).map((item) => ({
                    ...item,
                    [SELECTED_FIELD]: selectedState[idGetter(item)],
                  }))}
                  checkboxElement
                  style={{
                    height: clinicDomains.length > 0 ? "100%" : "250px",
                  }}
                  dataItemKey={DATA_ITEM_KEY}
                  selectedField={SELECTED_FIELD}
                  skip={page}
                  take={pageSize}
                  total={clinicDomains.length}
                  onPageChange={pageChange}
                  pageable={{
                    pageSizes: [10, 20, 30],
                  }}
                  sort={sort}
                  sortable={true}
                  onSortChange={(e) => {
                    setSort(e.sort);
                  }}
                >
                  <GridNoRecords style={{}}></GridNoRecords>
                  {/* <GridColumn filterable={false} field={SELECTED_FIELD} width="100px" /> */}
                  <GridColumn
                    className="cursor-default"
                    field="Clinic Domain"
                    title="Clinic Domain"
                  />
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isAddClinic && <AddClinic onClose={handleCloseClinic} />}
    </div>
  );
}
export default ClinicDomain;
